import { render } from "./iconLineaEducacion.vue?vue&type=template&id=54676579&scoped=true"
import script from "./iconLineaEducacion.vue?vue&type=script&lang=js"
export * from "./iconLineaEducacion.vue?vue&type=script&lang=js"

import "./iconLineaEducacion.vue?vue&type=style&index=0&id=54676579&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-54676579"

export default script